import React, { useState } from "react";
import {
Box,
Card,
Typography,
Button,
Checkbox,
FormControlLabel,
DialogTitle,
DialogContent,
DialogActions,
Snackbar,
Alert,
CircularProgress
} from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";
import { adminFetch } from "../services/adminFetch";
import ResponsiveDialog from "../components/ResponsiveDialog";
import { adminPageSx } from "../utils/adminResponsive";

export default function SuspendAdmin(){

const { state } = useLocation();
const navigate = useNavigate();

const admin = state?.admin;

const [notify,setNotify] = useState(true);
const [open,setOpen] = useState(false);
const [loading,setLoading] = useState(false);


const [snackbar,setSnackbar] = useState({
open:false,
message:"",
severity:"success"
});

const showSnackbar = (message,severity="success")=>{
setSnackbar({open:true,message,severity});
};

const handleCloseSnackbar = ()=>{
setSnackbar({...snackbar,open:false});
};




const handleSuspendAdmin = async () => {

setLoading(true);

try{

const endpoint =
admin.status === "suspended"
? "/api/admin/unsuspend"
: "/api/admin/suspend";

const data = await adminFetch(endpoint,{
method:"PUT",
body: JSON.stringify({
admin_id: admin.id,
notify
})
});

if(!data.status){
showSnackbar(data.message || "Operation failed","error");
setLoading(false);
return;
}

showSnackbar(
admin.status === "suspended"
? "Admin unsuspended successfully"
: "Admin suspended successfully"
);

setTimeout(()=>{
navigate("/admin/admins");
},1500);

}catch(err){
console.log(err);
showSnackbar("Server error","error");
}

setLoading(false);
setOpen(false);
};


return(

<Box sx={{ ...adminPageSx }}>

<Card sx={{ p:{ xs:2, sm:4 }, maxWidth:600, mx:"auto" }}>

<Typography variant="h5" sx={{mb:2, color:"#ed6c02"}}>
{admin?.status === "suspended" ? "Unsuspend Admin" : "Suspend Admin"}
</Typography>

<Typography sx={{mb:2}}>
Admin: <b>{admin?.email}</b>
</Typography>

<FormControlLabel
control={
<Checkbox
checked={notify}
onChange={(e)=>setNotify(e.target.checked)}
/>
}
label={`Notify admin (${admin?.email})`}
/>

<Button
fullWidth
variant="contained"
sx={{mt:3, bgcolor:"#ed6c02"}}
onClick={()=>setOpen(true)}
>
{admin?.status === "suspended"
? "Unsuspend Admin"
: "Suspend Admin"}
</Button>

</Card>




<ResponsiveDialog open={open} onClose={()=>setOpen(false)} maxWidth="xs">

<DialogTitle>
Confirm {admin?.status === "suspended" ? "Unsuspend" : "Suspension"}
</DialogTitle>

<DialogContent>
<Typography>
Are you sure you want to
{admin?.status === "suspended"
? " unsuspend this admin?"
: " suspend this admin?"}
</Typography>
</DialogContent>

<DialogActions>

<Button onClick={()=>setOpen(false)}>
No
</Button>

<Button
variant="contained"
sx={{bgcolor:"#ed6c02"}}
onClick={handleSuspendAdmin}
disabled={loading}
>
{loading
? <CircularProgress size={22} sx={{color:"white"}}/>
: "Yes"}
</Button>

</DialogActions>

</ResponsiveDialog>




<Snackbar
open={snackbar.open}
autoHideDuration={4000}
onClose={handleCloseSnackbar}
anchorOrigin={{vertical:"top",horizontal:"center"}}
>
<Alert severity={snackbar.severity} onClose={handleCloseSnackbar}>
{snackbar.message}
</Alert>
</Snackbar>

</Box>

);

}
